module.exports = __webpack_public_path__ + "a254e19e45a02a599689d517b97c98ea.svg";